import React from 'react';
import { Link } from 'react-router-dom';
import HeaderTitle from '../components/HeaderTitle';
const TitleWithUnderline = ({ children }) => (
  <div className="text-center mb-4">
    <h2 className="text-2xl font-semibold text-gray-800 mb-1">
      {children}
    </h2>
    <div className="w-16 h-1 bg-blue-600 mx-auto"></div>
  </div>
);

const AboutUs = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header Section with gradient background */}
      <HeaderTitle title={"About Us"}/>
      <nav className="mx-auto max-w-screen-xl px-2 py-2 sm:px-1 sm:py-2 lg:px-8" aria-label="Breadcrumb">
        <ol className="flex items-center gap-1 text-sm text-gray-600">
          <li>
            <Link to={'/'} className="block transition hover:text-gray-700">
              <span className="sr-only">Home</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="size-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                />
              </svg>
            </Link>
          </li>

          <li className="rtl:rotate-180">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="size-4"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </li>

          <li>
            <span className="text-gray-900 font-medium">About Us</span>
          </li>
        </ol>
      </nav>
      

      <div className="max-w-4xl mx-auto px-4">
        <div className="space-y-6 pb-6">
        <div className="bg-white p-6 rounded-lg shadow-md">
            <TitleWithUnderline>
              Welcome to Ultronics
            </TitleWithUnderline>
            <p className="text-gray-600 leading-relaxed">
              At Ultronics, we are pioneers in the field of Industrial cleaning / Ultrasonic cleaning technology. With a constant commitment to innovation and quality, we specialize in developing and manufacturing a wide range of special purpose machines for Industrial cleaning / Ultrasonic cleaning that cater to diverse industrial needs. Our special purpose machines are designed to deliver exceptional cleaning performance, ensuring the highest standards of cleanliness and efficiency for your applications.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md">
            <TitleWithUnderline>
              Our Expertise
            </TitleWithUnderline>
            <p className="text-gray-600 leading-relaxed">
              Our primary area of expertise lies in the development of special purpose machinery for Industrial and Ultrasonic cleaning applications. Our extensive portfolio of industrial and ultrasonic cleaning machines is tailored to meet the unique requirements of diverse industries, including automotive, aerospace, healthcare, electronics, and more. Trust our Ultrasonic cleaning solutions to deliver thorough, effective, and environmentally friendly cleaning for even the most complex components.
            </p>
          </div>

          


          <div className="bg-white p-6 rounded-lg shadow-md">
            <TitleWithUnderline>
              Customized Solutions
            </TitleWithUnderline>
            <p className="text-gray-600 leading-relaxed">
              We understand that each industry faces unique challenges, which is why we specialize in creating custom machines designed for specific purposes. Our team of skilled engineers collaborates closely with clients to develop tailored solutions that automate and optimize their individual processes. From the initial concept to the final implementation, we ensure that our custom machines seamlessly integrate into your workflow, ultimately enhancing productivity and operational efficiency.
            </p>
          </div>

          {/* Our Commitment Section */}
          <div className="bg-white p-6 rounded-lg shadow-md">
            <TitleWithUnderline>
              Our Commitment
            </TitleWithUnderline>
            <p className="text-gray-600 leading-relaxed">
              At Ultronics, quality and customer satisfaction are our top priorities. We employ advanced technologies and adhere to rigorous quality control standards to manufacture dependable and long-lasting cleaning machines that will produce consistent results. Our dedication to excellence extends to our customer service, where we provide comprehensive support and maintenance to ensure optimal performance of the machines.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;